import { getLoginUrl } from '@purecarslabs/signal-core/auth/auth'
import isTest from '@purecarslabs/signal-utils/env/isTest'
import isCurrentPathForAnonymousAccess from '@purecarslabs/signal-utils/isAnonymousPath'
import {
  DataMiddlewareType,
  ErrorWithResponseType,
  ResponseOrErrorType
} from './types'

// unfortunately, due to the way the middleware is instantiated and used, it is rather painful to ensure
// all callers provide the needLegacyAuth parameter, so we will also support setting this in a global
let gNeedLegacyAuth = false
export const setNeedLegacyAuth = (needLegacyAuth?: boolean) => {
  gNeedLegacyAuth = needLegacyAuth ?? false
}

let lastAuthRedirect: string
export const clearLastAuthRedirect = (): void => {
  lastAuthRedirect = ''
} // for unit testing
export const getLastAuthRedirect = (): string => lastAuthRedirect // for unit testing

// this middleware redirects to the sheriff if sign-in is required
const authRedirectMiddleware = (
  needLegacyAuth?: boolean
): DataMiddlewareType => async (
  respOrError?: ResponseOrErrorType
): Promise<ResponseOrErrorType> => {
  const resp =
    respOrError instanceof Error
      ? (respOrError as ErrorWithResponseType).response
      : respOrError

  if (resp) {
    const { status } = resp
    const inUnitTest = isTest()
    if (status === 401 && !isCurrentPathForAnonymousAccess()) {
      lastAuthRedirect = getLoginUrl(
        // if the global OR local parameters require legacy auth, then add the `legacy` parameter
        gNeedLegacyAuth || needLegacyAuth ? 'legacy' : undefined
      )
      if (!inUnitTest) {
        window.location.assign(lastAuthRedirect)
      }
      return undefined
    }
  }

  return respOrError
}

export default authRedirectMiddleware
